export { default } from './Price'
